export const handleTotalPriceToBePaid = ({ amount, moreThanValue, lessThanValue, defaultValue }) => {
  if (amount > 0) {
    return moreThanValue;
  }

  if (amount < 0) {
    return lessThanValue;
  }

  return defaultValue;
};
